import React, { useState } from 'react';
import PropTypes from 'prop-types';

/**
 * This is a helper component that will render an image with a fallback image if the src image fails to load.
 * @param {string} src - the source url for the image
 * @param {string} alt - the alt text for the image
 * @param {string} fallback - the fallback image url
 * @param {object} rest - any other props to pass to the img element
 * @returns 
 */
const ImageWithFallback = ({ src, alt, fallback, ...rest }) => {
  const [imgSrc, setImgSrc] = useState(src);

  const handleError = () => {
    setImgSrc(fallback); // Replace with placeholder on error
  };

  return <img src={imgSrc} alt={alt} onError={handleError} {...rest} />;
}

ImageWithFallback.propTypes = {
  src: PropTypes.string.isRequired
  , alt: PropTypes.string.isRequired
  , fallback: PropTypes.string.isRequired
}

export default ImageWithFallback;
